import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, InstagramIcon } from './icons/Icons';
import { Logo } from './Logo';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Sobre María Fernanda',
    href: '#sobre-mi'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Por Qué Skin Glow Studio22',
    href: '#por-que'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-brand-ivory ${isScrolled ? 'shadow-sm py-2' : 'py-3'}`} data-id="element-189">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-190">
        <a href="#inicio" className="block" data-id="element-191">
          <Logo size="md" data-id="element-192" />
        </a>

        {/* Actions — hamburger menu at all breakpoints */}
        <div className="flex items-center space-x-4 relative z-50" data-id="element-193">
          <a href="https://instagram.com/skinglowstudio22" target="_blank" rel="noopener noreferrer" className="text-brand-charcoal hover:text-brand-gold transition-colors" aria-label="Instagram" data-id="element-194">
            <InstagramIcon size={22} data-id="element-195" />
          </a>
          <button className="text-brand-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle Menu" data-id="element-196">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-197" /> : <MenuIcon size={28} data-id="element-198" />}
          </button>
        </div>
      </div>

      {/* Menu Drawer */}
      <AnimatePresence data-id="element-199">
        {isMobileMenuOpen && <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed inset-0 bg-brand-ivory z-40 flex flex-col pt-28 px-6 pb-8 h-screen overflow-y-auto md:left-auto md:right-0 md:w-[420px] md:shadow-2xl" data-id="element-200">
            <nav className="flex flex-col space-y-6 text-center mt-8" data-id="element-201">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-2xl font-serif text-brand-charcoal hover:text-brand-gold transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-202">
                  {link.name}
                </a>)}
              <div className="pt-8 flex flex-col items-center space-y-6" data-id="element-203">
                <a href="https://wa.me/12679841013" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="w-full max-w-xs py-3 bg-brand-gold text-white text-lg font-medium rounded-full hover:bg-brand-bronze transition-colors text-center" data-id="element-204">
                  Agenda tu cita
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
};